import React from 'react'
import {Link, Route, BrowserRouter as Router, Switch} from 'react-router-dom'
import {NavBar, Icon, InputItem} from 'antd-mobile'
import PropTypes from 'prop-types'
import './index.css'

var map

class AmapSearch extends React.Component {
    static propTypes = {}
    state = {
        name: '',
        show: true,
        showpannel:false,
    };

    componentDidMount() {
        const {AMap,} = window
        map = new AMap.Map('mapContainer', {
            resizeEnable: true,
            zoom: 12
        });
        map.plugin(['AMap.Autocomplete', 'AMap.PlaceSearch'], () => {
            var autoOptions = {
                // 输入框ID
                input: "keyword"
            }
            var autocomplete = new AMap.Autocomplete(autoOptions)//输入提示

            var placeSearch = new AMap.PlaceSearch({  //搜索
                map: map,
                pageSize: 5, // 单页显示结果条数
                pageIndex: 1, // 页码
                panel: "poiList", // 结果列表将在此容器中进行展示。
            });
            AMap.event.addListener(autocomplete, 'select', (e) => {
                //TODO 针对选中的poi实现自己的功能
                placeSearch.setCity(e.poi.adcode);
                placeSearch.search(e.poi.name);
                this.setState({showpannel:true});
            });
            //点击搜索列表中的数据
            AMap.event.addListener(placeSearch, 'selectChanged', (results)=> {
                //获取当前选中的结果数据
                const address=results.selected.data;
                console.log(results)
                this.setState({name: address.address + address.name, show: false});
               this.props.onSearch(address.pname+address.cityname+address.address + address.name, address.location.lng, address.location.lat);
            });

        })

    }

    keupSearch = (e) => {
        const {AMap,} = window
        if (e.keyCode == 84 || e.keyCode == 13) {

        }
       // console.log(e.keyCode);
    }


    render() {
        return (
            <div>
                {this.state.show ?
                    <div className='map_box' style={{height: '100%'}}>
                        <NavBar
                            mode="dark"
                            icon={<Icon type="left"/>}
                            onLeftClick={() => {
                                {
                                    const show = this.state.show;
                                    this.setState({show: !show})
                                }
                            }}
                        >选择补卡地址</NavBar>
                        <div id="page">
                        <div id="mapContainer"></div>
                        <div id="searchBox">
                            <InputItem id="keyword"
                                       value={this.state.name}
                                       onChange={value => this.setState({name: value})}
                                       onKeyUp={(e) => {
                                           this.keupSearch(e)
                                       }}
                                       placeholder="请输入补卡地址"
                                       clear
                            ></InputItem>
                            {/*<div id="clearSearchBtn">*/}
                                {/*<div class="del">&#10005;</div>*/}
                            {/*</div>*/}
                        </div>
                            {this.state.showpannel?
                                <div id="panel">
                                    <a id="showHideBtn" onClick={()=>{
                                        const showpannel=this.state.showpannel;
                                        this.setState({showpannel:!showpannel})
                                    }}></a>
                                    <div id="emptyTip">没有内容！</div>
                                    <div id="poiList">
                                    </div>
                                </div>:''
                            }

                        <div id="loader"></div>
                            <div style={{height:'50px'}}></div>
                        </div>
                        {/*<div className="map_search">*/}
                            {/*<InputItem id="keyword"*/}
                                       {/*value={this.state.name}*/}
                                       {/*onChange={value => this.setState({name: value})}*/}
                                       {/*onKeyUp={(e) => {*/}
                                           {/*this.keupSearch(e)*/}
                                       {/*}}*/}
                                       {/*placeholder="请输入补卡地址"*/}
                                       {/*clear*/}
                            {/*></InputItem>*/}
                        {/*</div>*/}
                        {/*<div id="addressbox"></div>*/}
                        {/*<div>{this.state.address}</div>*/}

                    </div>
                    : ''
                }
            </div>
        )
    }
}

export default AmapSearch
